<template lang="html">
  <div class="dashboard" :class="thisClass" :style="thisStyle">
    <div class="container-fluid">
      <div class="row">
        <div class="col-10 offset-1">
          <div class="row" :class="(center?'justify-content-center':'')">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bg: {
      type: String,
      default: ''
    },
    center: {
      type: Boolean
    },
    column: {
      type: Boolean
    }
  },
  computed: {
    thisClass: function () {
      if (this.center && this.column) {
        return 'center column'
      } else if (this.center) {
        return 'center'
      } else if (this.column) {
        return 'column'
      }
    },
    thisStyle: function () {
      if (this.bg) {
        var style = 'background-image: url(' + this.bg + ');'
        return style
      }
    }
  }
}
</script>

<style lang="scss">
  .dashboard {
    min-height: calc(100vh - 54px);
    background-position: center;
    background-size: cover;
    padding-top: 100px;
    flex-wrap: wrap;
    flex-wrap: wrap;
    display: flex;
    min-height: 100vh;
    background-color: #E5E6EB;

    &.center .container .row {
      align-items: center;
    }
    &.column .container .row{
      flex-direction: column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/dashboard/Dashboard.vue